// material-ui
import PropTypes from 'prop-types';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ isHeader }) {
  return (
    <img
      src="/logo.png"
      alt="Farmer Survey Logo"
      width="150"
      style={{
        height: isHeader ? '55px' : 'auto',
        objectFit: 'contain',
        objectPosition: 'left center',
        display: 'block'
      }}
    />
  );
}

LogoMain.propTypes = { isHeader: PropTypes.bool };
